/*
Copyright 2022 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
const URL_REGEX = /^([^?#]*)(\??[^#]*)(#?.*)$/;
const getSeparator = queryString => {
  if (queryString === "") {
    return "?";
  }
  if (queryString === "?") {
    return "";
  }
  return "&";
};
export default ({
  dateProvider,
  orgId
}) => (ecid, url) => {
  const ts = Math.round(dateProvider().getTime() / 1000);
  const adobemc = encodeURIComponent(`TS=${ts}|MCMID=${ecid}|MCORGID=${encodeURIComponent(orgId)}`);
  const [, location, queryString, fragment] = url.match(URL_REGEX);
  const separator = getSeparator(queryString);
  return `${location}${queryString}${separator}adobe_mc=${adobemc}${fragment}`;
};